import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { databasePromise } from "configuration";

export const useOptions = () => {
  const [categories, setCategories] = useState([]);
  const [dietaryPreferences, setDietaryPreferences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);

    databasePromise.then(async db => {
      try {
        const [categoriesSnapshot, dietarySnapshot] = await Promise.all([
          getDocs(collection(db, "categories")),
          getDocs(collection(db, "dietaryPreferences")),
        ]);

        setCategories(categoriesSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name || doc.id,
          ...doc.data(),
        })));

        setDietaryPreferences(dietarySnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name || doc.id,
          ...doc.data(),
        })));

        setError(null);
      } catch (err) {
        console.error("Error fetching filter options:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    });
  }, []);

  return { categories, dietaryPreferences, loading, error };
};